/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './auth-footer.component.less.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@ngx-translate/core/src/translate.pipe';
import * as i3 from '@ngx-translate/core/src/translate.service';
import * as i4 from '@angular/common';
import * as i5 from '../../../../app/auth/auth-footer/auth-footer.component';
import * as i6 from '../../../../app/core/app-memory.service';
const styles_AuthFooterComponent:any[] = [i0.styles];
export const RenderType_AuthFooterComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_AuthFooterComponent,data:{}});
function View_AuthFooterComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),6,'div',[['class',
      'link-ireland']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),3,'a',([] as any[]),[[8,'href',4]],(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(3,(null as any),['',' ',''])),
      i1.ɵpid(131072,i2.TranslatePipe,[i3.TranslateService,i1.ChangeDetectorRef]),
      i1.ɵpid(131072,i2.TranslatePipe,[i3.TranslateService,i1.ChangeDetectorRef]),
      (_l()(),i1.ɵted(-1,(null as any),['\n    ']))],(null as any),(_ck,_v) => {
    const currVal_0:any = i1.ɵinlineInterpolate(1,'',_v.context.$implicit.url,'');
    _ck(_v,2,0,currVal_0);
    const currVal_1:any = i1.ɵunv(_v,3,0,i1.ɵnov(_v,4).transform('AUTH.navigateTo'));
    const currVal_2:any = i1.ɵunv(_v,3,1,i1.ɵnov(_v,5).transform(('CORE.' + _v.context.$implicit.country)));
    _ck(_v,3,0,currVal_1,currVal_2);
  });
}
export function View_AuthFooterComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),8,'footer',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),
      (null as any),1,(null as any),View_AuthFooterComponent_1)),i1.ɵdid(3,802816,
      (null as any),0,i4.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],
      {ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵeld(5,0,(null as any),(null as any),2,'div',[['class','copy']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(6,
          (null as any),['© ',' Equine MediRecord. ',''])),i1.ɵpid(131072,i2.TranslatePipe,
          [i3.TranslateService,i1.ChangeDetectorRef]),(_l()(),i1.ɵted(-1,(null as any),
          ['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i5.AuthFooterComponent = _v.component;
    const currVal_0:any = _co.availableCountries;
    _ck(_v,3,0,currVal_0);
  },(_ck,_v) => {
    var _co:i5.AuthFooterComponent = _v.component;
    const currVal_1:any = _co.appMemory.year;
    const currVal_2:any = i1.ɵunv(_v,6,1,i1.ɵnov(_v,7).transform('CONTACTS.allRightReserved'));
    _ck(_v,6,0,currVal_1,currVal_2);
  });
}
export function View_AuthFooterComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-auth-footer',
      ([] as any[]),(null as any),(null as any),(null as any),View_AuthFooterComponent_0,
      RenderType_AuthFooterComponent)),i1.ɵdid(1,114688,(null as any),0,i5.AuthFooterComponent,
      [i6.AppMemoryService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const AuthFooterComponentNgFactory:i1.ComponentFactory<i5.AuthFooterComponent> = i1.ɵccf('app-auth-footer',
    i5.AuthFooterComponent,View_AuthFooterComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdnN0cy93b3JrLzEvcy9lbXItd2ViYXBwL3NyYy9hcHAvYXV0aC9hdXRoLWZvb3Rlci9hdXRoLWZvb3Rlci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS92c3RzL3dvcmsvMS9zL2Vtci13ZWJhcHAvc3JjL2FwcC9hdXRoL2F1dGgtZm9vdGVyL2F1dGgtZm9vdGVyLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUvdnN0cy93b3JrLzEvcy9lbXItd2ViYXBwL3NyYy9hcHAvYXV0aC9hdXRoLWZvb3Rlci9hdXRoLWZvb3Rlci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvdnN0cy93b3JrLzEvcy9lbXItd2ViYXBwL3NyYy9hcHAvYXV0aC9hdXRoLWZvb3Rlci9hdXRoLWZvb3Rlci5jb21wb25lbnQudHMuQXV0aEZvb3RlckNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxmb290ZXI+XG4gICAgPGRpdiBjbGFzcz1cImxpbmstaXJlbGFuZFwiICpuZ0Zvcj1cImxldCBhdmFpbGFibGVDb3VudHJ5IG9mIGF2YWlsYWJsZUNvdW50cmllc1wiPlxuICAgICAgICA8YSBocmVmPVwie3thdmFpbGFibGVDb3VudHJ5LnVybH19XCI+e3snQVVUSC5uYXZpZ2F0ZVRvJyB8IHRyYW5zbGF0ZX19IHt7J0NPUkUuJyArIGF2YWlsYWJsZUNvdW50cnkuY291bnRyeSB8IHRyYW5zbGF0ZX19PC9hPlxuICAgIDwvZGl2PlxuICAgIDxkaXYgY2xhc3M9XCJjb3B5XCI+wqkge3t0aGlzLmFwcE1lbW9yeS55ZWFyfX0gRXF1aW5lIE1lZGlSZWNvcmQuIHt7ICdDT05UQUNUUy5hbGxSaWdodFJlc2VydmVkJyB8IHRyYW5zbGF0ZSB9fTwvZGl2PlxuPC9mb290ZXI+XG4iLCI8YXBwLWF1dGgtZm9vdGVyPjwvYXBwLWF1dGgtZm9vdGVyPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQ0k7TUFBQTtNQUE4RSxrREFDMUU7VUFBQTtVQUFBLDhCQUFtQzthQUFBO2FBQUE7TUFBd0Y7SUFBeEg7SUFBSCxXQUFHLFNBQUg7SUFBbUM7SUFBQTtJQUFBOzs7O29CQUYzQztNQUFBLHdFQUFRO2FBQUEsK0JBQ0o7TUFBQSxrRUFBQTtNQUFBO01BQUEsdUNBRU07TUFDTjtVQUFBLDBEQUFrQjtVQUFBO1VBQUEsNENBQWdHO1VBQUEsU0FDN0c7O0lBSnFCO0lBQTFCLFdBQTBCLFNBQTFCOzs7SUFHa0I7SUFBQTtJQUFBOzs7O29CQ0p0QjtNQUFBO29DQUFBLFVBQUE7TUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/$$_gendir/app/auth/auth-footer/auth-footer.component.ngfactory.ts